<template>
  <div>
    <div class="container">
      <div class="detailSwiper">
        <mt-swipe :auto="0">
          <mt-swipe-item v-for="(item, index) in swipeImgs" :key="index">
            <van-image :src="item" fit="cover" lazy-load class="swiperPic" />
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <div class="detail-tab b_fff">
        <div class="detail-tab-top">
          <div>
            <span class="title-short"> <span class="icon-tm" v-if="productInfo.UserType === 1">天猫</span>{{ productInfo.dtitle }} </span>
          </div>
          <div class="subBottom">
            <div class="tagOne status2">领券{{ productInfo.couponPrice | filterCoupon }}元</div>
          </div>
          <div class="priceBox">
            <div class="leftPart">
              <i class="symbol">￥</i>
              <span class="price">{{ productInfo.actualPrice | toFixedInt }}.{{ productInfo.actualPrice | toFixedDecimal }}</span>
            </div>
            <div class="modify">
              <div class="label">到手价</div>
              <div class="history">￥{{ productInfo.originalPrice | toFixed }}</div>
            </div>
          </div>
        </div>
        <div class="couponCard tapActive" @click="getCouponNow">
          <div class="leftPart">
            <div class="leftPartCon">
              <div class="subTopPart">
                <i class="symbol">￥</i>
                <span class="price">{{ productInfo.couponPrice | filterCoupon }}</span>
                <i class="label">店铺优惠券</i>
              </div>
              <div class="subBottomPart">
                <div class="label">有效期</div>
                <div class="time oneRow">{{ productInfo.couponStartTime | formatTime('YYYY.MM.DD') }}-{{ productInfo.couponEndTime | formatTime('YYYY.MM.DD') }}</div>
              </div>
            </div>
          </div>
          <div class="rightPart">立即领券</div>
          <span class="iconfont icon-youhuiquan1 modifyOne"></span>
        </div>
      </div>
      <!-- 说明模块 -->
      <div class="b_fff process">
        <div class="title-padd border-b flex space-between" @click="slideToggle">
          <div class="fanli_left flex">
            <span>免搜流程</span>
            <div class="flex" v-if="!rebateOpen">
              <div class="tag">淘口令</div>
              <div class="tag">购买</div>
            </div>
          </div>
          <div class="detail-allow-right" :class="[rebateOpen ? 'rotate-45' : '']"></div>
        </div>
        <div class="kind-list__item-bd kind-list__item-bd_show" v-if="rebateOpen">
          <div class="fanli_step b_fff">
            <div class="fl_jiantou">
              <div class="jt_left">
                <div class="jt-icon"></div>
                <div class="text">
                  <span class="t_f05c61">打开淘宝App</span>
                  <span>领取优惠券</span>
                </div>
              </div>
            </div>
            <div class="fl_xstep">
              <div class="st_left">
                <div class="xstep_icon">
                  <span class="iconfont icon-dingdan"></span>
                </div>
                <div class="p_left">
                  <span>点击立即领券</span>
                  <span>复制淘口令</span>
                </div>
              </div>
              <div class="st_right">
                <div class="xstep_icon">
                  <span class="iconfont icon-taobao2"></span>
                </div>
                <div class="p_right">
                  <span>直接下单购买</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 图片详情 -->
      <div class="pro-detail b_fff">
        <div class="p-titel">
          <span>免搜图解</span>
          <span class="t_999">DETAILS</span>
        </div>
        <div class="pro-contain">
          <img v-for="(item, index) in unsearchImgs" :key="index" v-lazy="youpPath + item" />
        </div>
      </div>
      <!-- 底部 -->
      <div class="pro-detail-btn flex">
        <div class="leftPart">
          <div class="secondaryBtn tapActive" @click="$router.push({ name: 'souhuo' })">
            <div class="con">
              <span class="iconfont icon-shouye1"></span>
              <span>首页</span>
            </div>
          </div>
          <div class="secondaryBtn tapActive" @click="contactCs">
            <div class="con">
              <span class="iconfont icon-kefu2"></span>
              <span>客服</span>
            </div>
          </div>
          <div class="secondaryBtn"></div>
        </div>
        <div class="rightPart">
          <div class="mainBtn tapActive" @click="shareClick">分享商品</div>
          <div class="mainBtn tapActive" @click="getCouponNow">立即领券</div>
        </div>
      </div>
    </div>
    <coupon-dialog v-if="couponDialogShow" :err-feedback="false" :data-info="couponDataInfo" @close="couponDialogShow = false"> </coupon-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import CouponDialog from '@/components/smartComponent/CouponDialog'
import { IMG_BASE_URL } from '@/config'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { GetGoodsDetails, GetPrivilegeLink } from '@/api/dtk'
import baseUtil from '@/utils/base'
import { DTK_ENTRANCE_TYPE } from '@/constants/index'

export default {
  data() {
    return {
      swipeImgs: [],
      ID: '',
      isLoding: false,
      dtkEntranceType: DTK_ENTRANCE_TYPE['榜单'],
      // 平台返利金额
      rebatePrice: 0,
      rebateProductId: null,
      productInfo: {},
      couponDataInfo: {},
      rebateOpen: true,
      // 优惠券弹窗
      couponDialogShow: false,
      youpPath: IMG_BASE_URL,
      unsearchImgs: ['/upaiyun/Sys/20181227/5004761528823246242.png', '/upaiyun/Sys/20181227/5176621376970347391.png', '/upaiyun/Sys/20181227/5097045002788876396.png']
    }
  },
  components: {
    CouponDialog
  },
  mounted() {
    this.ID = this.$route.query.id
    this.dtkEntranceType = this.$route.query.dtkEntranceType ? this.$route.query.dtkEntranceType : DTK_ENTRANCE_TYPE['榜单']
    if (!this.ID) {
      setTimeout(() => {
        Toast('该信息不存在！')
        this.$router.go(-1)
      }, 1000)
      return
    }
    if (this.getGoodsDetailData && this.getGoodsDetailData.goodsId === this.ID) {
      this.handlerGoodsDataInfo(this.getGoodsDetailData)
      return
    }
    this.fetchData()
  },
  computed: {
    ...mapGetters(['loginState', 'getIsApp', 'getIsAuthorized', 'getGoodsDetailData'])
  },
  methods: {
    ...mapMutations(['AUTHORIZE_POPUP_SHOW']),
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.handleRes(GetGoodsDetails({ goodsId: this.ID }))
    },
    handleRes(resPormise) {
      resPormise
        .then((res) => {
          Indicator.close()
          this.handlerGoodsDataInfo(res.Data)
        })
        .catch((res) => {
          Indicator.close()
          this.showIKnowMegBox(res.ErrMsg)
        })
    },
    handlerGoodsDataInfo(goodsDetailData) {
      this.productInfo = goodsDetailData
      let imgs = goodsDetailData.imgs
      try {
        if (imgs) imgs = goodsDetailData.imgs.split(',')
        else imgs = []
      } catch (error) {
        if (imgs) imgs = goodsDetailData.imgs
        else imgs = []
      }
      this.swipeImgs = [goodsDetailData.mainPic, ...imgs]
      // 分享
      let shareLink = `daTaoKeGoodsDetail,id,${this.ID}`
      baseUtil.shareApi(goodsDetailData.ProductName, goodsDetailData.ProductHeadUrl, shareLink)
    },
    unLoginModal() {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    },
    // 立即领券
    getCouponNow() {
      if (this.isLoding) return
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.isLoding = true
      GetPrivilegeLink({ goodsId: this.ID, dtkEntranceType: this.dtkEntranceType })
        .then((res) => {
          this.isLoding = false
          Indicator.close()
          this.setDataInfo(res)
        })
        .catch((res) => {
          this.isLoding = false
          Indicator.close()
          this.showIKnowMegBox(res.ErrMsg)
        })
    },
    setDataInfo(res) {
      this.couponDataInfo = {
        goodsImg: this.productInfo.mainPic,
        pwdStr: res.Data
      }
      this.couponDialogShow = true
    },
    showIKnowMegBox(errMsg) {
      MessageBox({
        title: '提示',
        message: errMsg,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          this.$router.go(-1)
        }
      })
    },
    showErrMsgBox(msg = '无', confirmTxt = '我知道了', showCancel = true, cancelTxt = '取消', confirmFn, cancelFn) {
      MessageBox({
        title: '提示',
        message: msg,
        showCancelButton: showCancel,
        confirmButtonText: confirmTxt,
        cancelButtonText: cancelTxt,
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          if (confirmFn) confirmFn()
        } else {
          if (cancelFn) cancelFn()
        }
      })
    },
    // 进入商品详情页
    entoProductDetail() {
      if (!this.rebateProductId) return
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: this.rebateProductId
        }
      })
    },
    // 说明切换
    slideToggle() {
      this.rebateOpen = !this.rebateOpen
    },
    // 客服
    contactCs() {
      this.$router.push({
        name: 'posterDetail',
        query: {
          isContact: 1
        }
      })
    },
    shareClick() {
      if (this.loginState) {
        let shareID = this.ID
        let type = 19
        this.$router.push({
          name: 'ShareByImg',
          query: {
            type: 'goods',
            productId: shareID,
            pageType: type
          }
        })
      } else {
        this.unLoginModal()
      }
    }
  },
  filters: {
    toFixed(value) {
      if (!value) {
        value = 0
      }
      return parseFloat(value).toFixed(2)
    },
    toFixedInt(val) {
      if (!val) {
        val = 0
      }
      return parseFloat(val)
        .toFixed(2)
        .split('.')[0]
    },
    toFixedDecimal(value) {
      if (!value) {
        value = 0
      }
      return parseFloat(value)
        .toFixed(2)
        .split('.')[1]
    },
    filterCoupon(val) {
      if (val) {
        let pattern = /\D*([\d+.*\d*]+)\D*([\d+.*\d*]*)\D*/gi
        if (pattern.test(val)) {
          if (RegExp['$2']) {
            return RegExp['$2']
          } else if (RegExp['$1']) {
            return RegExp['$1']
          } else {
            return val
          }
        } else {
          return val
        }
      } else {
        return val
      }
    }
  }
}
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.container {
  font-size: 12px;
  padding-bottom: 4em;
}
.detailSwiper {
  padding: 3%;
}
.detailSwiper .mint-swipe {
  width: 25em;
  height: 25em;
  margin: 0 auto;
  position: relative;
  overflow: visible;
  background: #fff;
}
.detailSwiper .mint-swipe .swiperPic {
  width: 25em;
  height: 25em;
}
.swiper-btn-view {
  height: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.fs-26 {
  font-size: 13px;
}
.t_999 {
  color: #999;
}
.flex {
  display: flex;
}
.detail-tab {
  padding: 3% 4% 4%;
  box-sizing: border-box;
  .couponCard {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 70px;
    background: #fdebe7;
    margin-top: 4%;
    border-radius: 4px;
    overflow: hidden;
    color: #f23030;
    .modifyOne {
      position: absolute;
      left: -10px;
      bottom: -5px;
      opacity: 0.08;
      color: #f69999;
      font-size: 50px;
      transform: rotate(-50deg);
    }
    .leftPart {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      flex: 1;
      height: 100%;
      box-sizing: border-box;
      padding: 5px 0 5px 24px;
      &::before {
        content: '';
        width: 9px;
        height: 9px;
        border-radius: 50%;
        display: block;
        border: 1px solid transparent;
        position: absolute;
        background: #fff;
        top: -4.5px;
        right: -5.5px;
      }
      &::after {
        content: '';
        width: 9px;
        height: 9px;
        border-radius: 50%;
        display: block;
        border: 1px solid transparent;
        position: absolute;
        background: #fff;
        bottom: -4.5px;
        right: -5.5px;
      }
      .subTopPart {
        font-size: vw(13);
        line-height: vw(13);
        .price {
          font-size: vw(28);
          line-height: vw(28);
          font-weight: 500;
        }
        .label {
          position: relative;
          top: vw(-1);
        }
      }
      .subBottomPart {
        display: flex;
        align-items: center;
        font-size: vw(12);
        margin-top: vw(4);
        .label {
          margin-right: 4px;
          line-height: vw(12);
        }
        .time {
          line-height: vw(12);
        }
      }
    }
    .rightPart {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 120px;
      height: 100%;
      font-weight: 700;
      font-size: vw(15);
      border-left: 1px dashed #fff;
    }
  }
}
.detail-tab span {
  margin-right: 2%;
}
.process {
  margin-top: 3%;
}
.border-b {
  border-bottom: 1px solid #f2f2f2;
}
.tag {
  display: inline-block;
  border: 1px solid #f23030;
  padding: 0 15px;
  color: #f23030;
  font-size: 13px;
  border-radius: 6px;
}
.title-padd {
  padding: 3% 4%;
  position: relative;
  transition: 0.3s;
}
.space-between {
  justify-content: space-between;
}
.fanli_left {
  align-items: center;
}
.fanli_left span {
  margin-right: 20px;
  display: block;
  flex-shrink: 0;
  font-size: 15px;
}
.fanli_left .tag {
  margin-right: 10px;
  word-break: keep-all;
}
.pro-detail {
  margin-top: 3%;
}
.p-titel {
  margin: 0 4%;
  padding: 3% 0;
  border-bottom: 1px solid #f2f2f2;
}
.p-titel span {
  margin-right: 14px;
  font-size: 15px;
}
.p-titel .t_999 {
  font-size: 13px;
}
.pro-contain {
  padding: 3% 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.pro-contain img {
  width: 100%;
}
.pro-nav {
  position: relative;
  text-align: center;
  width: 30%;
  line-height: 20px;
  color: #999;
  vertical-align: -webkit-baseline-middle;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.pro-nav .iconfont {
  font-size: 1.5em;
}
.pro-nav-txt {
  font-size: 13px;
}
.souhuo-btn {
  background: #f23030;
  color: #fff;
  width: 70%;
  line-height: 57px;
  display: block;
  font-size: 15px;
}
.rebate-btn {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  background: #000;
  color: #fff;
  font-size: 15px;
}
/* .isours-goods .rebate-btn{
      width: 38%;
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      background: #000;
      color: #fff;
      font-size: 15px;
    }
    .isours-goods .pro-nav{
      width: 24%;
    }
    .isours-goods .souhuo-btn{
      width: 38%;
    } */
.detail-allow-right {
  border: 2px solid #c8c8cd;
  border-bottom-width: 0;
  border-left-width: 0;
  content: ' ';
  top: 50%;
  right: 20px;
  position: absolute;
  width: 5px;
  height: 5px;
  -webkit-transform: translateY(-50%) rotate(135deg);
  transform: translateY(-50%) rotate(135deg);
}
.rotate-45 {
  transform: rotate(-45deg);
  transition: 0.4s linear 0s;
}
.kind-list__item-bd {
  height: 0;
  overflow: hidden;
}
.kind-list__item-bd_show {
  height: auto;
}
.fanli_step {
  padding: 3% 0;
}
.fl_xstep {
  display: flex;
  width: calc(100% - 10px);
  padding: 3% 1%;
  align-items: flex-start;
  margin-top: -7em;
}
.fl_jiantou {
  display: flex;
  width: calc(100% - 20px);
  padding: 3% 1%;
  align-items: center;
  height: 4em;
}
.jt_left {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 21%;
  margin-right: 2.5em;
  z-index: 10;
}
.jt-icon {
  position: absolute;
  right: -4px;
  color: #ddd;
  font-size: 12px;
  border-top: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 8px solid #ddd;
}
.text {
  width: 100%;
}
.t_f05c61 {
  color: #f05c61 !important;
}
.text .t_f05c61 {
  border-bottom: 1px solid #ddd;
}
.text span {
  display: block;
  font-size: 13px;
  color: #999;
  line-height: 2em;
  word-break: keep-all;
}
.fl_jiantou > div {
  text-align: center;
  flex: 1;
}
.fl_jiantou > div:first-child {
  width: 34%;
  flex: initial;
  margin-left: 35%;
}
.fl_xstep > div {
  flex: 1;
  position: relative;
  text-align: center;
  font-size: 13px;
}
.fl_xstep > div span {
  display: block;
}
.xstep_icon .iconfont {
  font-size: 20px;
}
.xstep_icon {
  width: 4em;
  height: 4em;
  line-height: 4em;
  background: #f05c61;
  border-radius: 100%;
  color: #fff;
  border: 10px solid #fff;
  margin: 0 auto 0;
  position: relative;
}
.detail-tab-top {
  width: 100%;
  border-bottom: 1px solid rgba(241, 241, 241, 0.5);
}
.title-left {
  width: 85%;
}
.title-short {
  font-size: 16px;
  width: 100%;
  max-height: 46em;
  overflow: hidden;
  display: block;
  margin-bottom: 12px;
}
i {
  font-style: normal;
}
.subBottom {
  display: flex;
  flex-wrap: wrap;
  .tagOne {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #ffab85;
    height: vw(18);
    border-radius: vw(3);
    margin-right: vw(5);
    box-sizing: border-box;
    font-size: vw(12);
    overflow: hidden;
    .label {
      background-color: #ec0536;
      padding: 0 vw(4);
      color: #fff;
    }
    .content {
      background-color: #fbf3c9;
      padding: 0 vw(4);
      color: #ec0536;
    }
    &.status2 {
      color: #f23030;
      background-color: #fdebe7;
      padding: 0 vw(6);
    }
  }
}
.priceBox {
  display: flex;
  align-items: center;
  color: #ff0036;
  margin: 8px 0;
  .leftPart {
    margin-right: 8px;
  }
  .modify {
    font-style: 10px;
    color: #ff0036;
    line-height: 13px;
    .history {
      color: #bbbbbb;
      text-decoration: line-through;
    }
  }
  .price {
    font-size: 30px;
    line-height: 30px;
    letter-spacing: -1px;
  }
  .symbol {
    font-size: 16px;
  }
}
.title-short .icon-tm {
  color: #fff;
  background: #dd2727;
  padding: 1px 6px;
  font-size: 12px;
  border-radius: 20px;
}
.title-price div,
span {
  display: inline;
}
.title-price .t_999 {
  text-decoration: line-through;
}
.price-tag {
  margin-right: 10px;
  background-color: #f23030;
  font-size: 12px;
  color: #fff;
  padding: 3px 6px 3px 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  position: relative;
  top: -1px;
}
.price-char {
  font-size: 4%;
}
.price-discount-int {
  font-size: 28px;
}
.price-discount-decimal {
  font-weight: bold;
  margin-right: 10px;
}
.title-right {
  width: 15%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.title-right button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.title-right .iconfont {
  font-size: 20px;
}
.detail-tab-bottom {
  color: #999;
}
.detail-tab-bottom .rebate-tag {
  background: #ffe7bb;
  color: #ff6d2c;
  border: 1px solid #ffd8bf;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 11px !important;
}
.detail-tab-bottom .rebate-span {
  font-size: 13px;
  margin-top: 15px;
  display: block;
  margin-left: 72px;
}
.rebate-tag-sure {
  position: relative;
  background: #fff;
  color: #f23030;
  border: 1px solid #f23030;
  padding: 2px 8px;
  font-size: 12px !important;
  border-radius: 3px;
  display: inline-block;
  box-sizing: border-box;
}
.rebate-tag-sure:before {
  content: '';
  width: 4px;
  height: 6px;
  border-radius: 0 50% 50% 0;
  display: block;
  border: 1px solid;
  position: absolute;
  top: 7px;
  background: #fff;
  left: -1px;
  border-left: none;
}
.rebate-tag-sure:after {
  content: '';
  width: 4px;
  height: 6px;
  border-radius: 50% 0 0 50%;
  display: block;
  border: 1px solid;
  position: absolute;
  top: 7px;
  background: #fff;
  right: -1px;
  border-right: none;
}
img[lazy='loading'] {
  width: 100%;
  height: auto;
  background: #f5f5f5;
}
</style>
